export const contactUsConstants = {
    CONTACTUS_REQUEST : 'CONTACTUS_REQUEST',
    CONTACTUS_SUCCESS : 'CONTACTUS_SUCCESS',
    CONTACTUS_FAILURE : 'CONTACTUS_FAILURE',
    CONTACTUS_CLEAR : 'CONTACTUS_CLEAR'
}


// WEBPACK FOOTER //
// ./src/store/constants/contactUs.constants.js